module.exports = "<!-- Main view/routes wrapper-->\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0